import { Button, Grid, Popover, Typography } from '@mui/material';
import { BadgeHeader } from '../badge-header';
import { BadgeNoContent } from '../badge-no-content';
import { BadgeLoading } from '../badge-loading';
import { BadgeContainer } from '../badge-container';
import { BadgeInfiniteScroll } from '../badge-infinite-scroll';
import { styles } from './styles';
import { IBadge } from './types';

export const Badge = ({
  open,
  id,
  buttonProps,
  popoverProps,
  children,
  onOpen,
  onClose,
}: IBadge) => {
  const { title, icon } = buttonProps;
  const { anchorEl } = popoverProps;

  return (
    <Grid sx={styles.wrapper(open)}>
      <Button
        aria-describedby={open ? id : undefined}
        aria-expanded={open}
        id={id}
        sx={styles.button}
        variant="outlined"
        startIcon={icon}
        onClick={onOpen}
      >
        <Typography sx={styles.title}>{title}</Typography>
      </Button>
      <Popover
        id={id}
        sx={styles.popover}
        PaperProps={{ style: styles.paper }}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        transitionDuration={{ appear: 300, enter: 300, exit: 10 }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Grid sx={styles.container}>{children}</Grid>
      </Popover>
    </Grid>
  );
};

Badge.Header = BadgeHeader;
Badge.NoContent = BadgeNoContent;
Badge.Loading = BadgeLoading;
Badge.Container = BadgeContainer;
Badge.InfiniteScroll = BadgeInfiniteScroll;
